module.exports = __webpack_public_path__ + "static/media/image2.a90535c3.jpg";